// Generated by CoffeeScript 2.7.0
var TagsTab;

export default TagsTab = Vue.extend({
  props: {
    initialActiveTab: {
      type: String
    }
  },
  data: function() {
    return {
      activeTab: this.initialActiveTab
    };
  },
  template: `<div class="tags-tab sidebar-tabs tabs">
  <div class="tab-navs reverse nav">
    <div :class="tabClass('user')" @click="checkActiveTab('user')">成员标签</div>
    <div :class="tabClass('receipt')" @click="checkActiveTab('receipt')">消息标签</div>
  </div>
</div>`,
  methods: {
    checkActiveTab: function(activeTab) {
      this.activeTab = activeTab;
      return this.$emit('tabChanged', activeTab);
    },
    tabClass: function(tab) {
      return {
        'nav-item': true,
        active: tab === this.activeTab
      };
    }
  }
});
